import axios from 'axios'
import C from './Confg';
import S from '../lib/Security'
var CryptoJS = require("crypto-js");
var Buffer = require('buffer/').Buffer
const Network = {
    getApi: async function (param) {
        var res = await axios({
            url: C.getUrl() + '/api/' + param,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': localStorage.getItem("authorization"),
                Accept: '*/*'
            },
        })

        return res;

    },
    postApi: async function (param, value) {
        let inputData = S.getEncryptedJSON(value);
        var res = await axios({
            url: C.getUrl() + '/api/' + param,
            method: 'POST',
            data: JSON.stringify(inputData),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("authorization")}`,
                'Access-Control-Allow-Origin': '*',
                 Accept: '*/*'
             },
        })

        return res;

    },
    getRSAApi: async function (param) {
        var res = await axios({
            url: C.getUrl() + param,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': localStorage.getItem("authorization"),
                Accept: '*/*',
            },
        })

        return res;

    },
    
    getCompanyMaster: async function (param) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username'),
                    tenantId:localStorage.getItem('tenantId'),
                };
                console.log("data:"+JSON.stringify(data));
        let inputData = S.getEncryptedJSON(data);
        const jsonString = JSON.stringify(inputData);
        console.log("jsonString:"+jsonString);
        const encodedString = Buffer.from(jsonString).toString('base64');
        console.log("encodedString:"+encodedString);
        var finalUrl = C.getP2PUrl() + param + encodedString
        window.open(finalUrl, "_blank");
    },

    getCRoleConfigMaster: async function (param) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username'),
                    tenantId: localStorage.getItem('tenantId'),
                };
                console.log("data:"+data);
        let inputData = S.getEncryptedJSON(data);
        console.log("inputData:"+inputData);
        const jsonString = JSON.stringify(inputData);
        console.log("jsonString:"+jsonString);
        const dyanmicValue = "&dynamicValueOne="+localStorage.getItem('tenantId');
        console.log("dyanmicValue:"+dyanmicValue);
        const encodedString = Buffer.from(jsonString).toString('base64');
        console.log("encodedString:"+encodedString);
        var finalUrl = C.getP2PUrl() + param + encodedString + dyanmicValue
        window.open(finalUrl, "_blank");
    },

    getConfiguration: async function (param) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username')
                };
        let inputData = S.getEncryptedJSON(data);
        const jsonString = JSON.stringify(inputData);
        const encodedString = Buffer.from(jsonString).toString('base64');
        var finalUrl = C.getP2PUrl() + param + encodedString
        window.open(finalUrl, "_blank");
    },

    getCompanyMasterRent: async function (param) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username'),
                    tenantId:localStorage.getItem('tenantId'),
                };
                console.log("data:"+JSON.stringify(data));
        let inputData = S.getEncryptedJSON(data);
        const jsonString = JSON.stringify(inputData);
        console.log("jsonString:"+jsonString);
        const encodedString = Buffer.from(jsonString).toString('base64');
        console.log("encodedString:"+encodedString);
        var finalUrl = C.getRentUrl() + param + encodedString
        window.open(finalUrl, "_blank");
    },

    getCRoleConfigMasterRent: async function (param) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username'),
                    tenantId: localStorage.getItem('tenantId'),
                };
                console.log("data:"+data);
        let inputData = S.getEncryptedJSON(data);
        console.log("inputData:"+inputData);
        const jsonString = JSON.stringify(inputData);
        console.log("jsonString:"+jsonString);
        const dyanmicValue = "&dynamicValueOne="+localStorage.getItem('tenantId');
        console.log("dyanmicValue:"+dyanmicValue);
        const encodedString = Buffer.from(jsonString).toString('base64');
        console.log("encodedString:"+encodedString);
        var finalUrl = C.getRentUrl() + param + encodedString + dyanmicValue
        window.open(finalUrl, "_blank");
    },

    getConfigurationRent: async function (param) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username')
                };
        let inputData = S.getEncryptedJSON(data);
        const jsonString = JSON.stringify(inputData);
        const encodedString = Buffer.from(jsonString).toString('base64');
        var finalUrl = C.getRentUrl() + param + encodedString
        window.open(finalUrl, "_blank");
    },

    getCommonConfiguration: async function (param,name,switchType) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username'),
                    tenantId:localStorage.getItem('tenantId'),
                    labelName:name,
                    switchType:switchType
                };
                console.log("data :",data);
        let inputData = S.getEncryptedJSON(data);
        const jsonString = JSON.stringify(inputData);
        const encodedString = Buffer.from(jsonString).toString('base64');
        var finalUrl = C.getP2PUrl() + param + encodedString
        window.open(finalUrl, "_blank");
    },

    getCommonConfigurationForRent: async function (param,name,switchType) {
        var data = {
                    callViaTms: 'Y',
                    tenantEmployee: localStorage.getItem('username'),
                    tenantId:localStorage.getItem('tenantId'),
                    labelName:name,
                    switchType:switchType
                };
                console.log("data :",data);
        let inputData = S.getEncryptedJSON(data);
        const jsonString = JSON.stringify(inputData);
        const encodedString = Buffer.from(jsonString).toString('base64');
        var finalUrl = C.getRentUrl() + param + encodedString
        window.open(finalUrl, "_blank");
    },
}
export default Network;